export default __webpack_public_path__ + "img/half-star.14a79b1.svg";